module.exports = __webpack_public_path__ + "static/media/tanks.6a914369.gif";